import CustomerTypeHandler from "../components/customerTypeHandler";
import couponHandler from "../components/couponHandler";

document.addEventListener("DOMContentLoaded", () => {
  // Only run this code on checkout page
  const checkoutForm = document.querySelector("form.checkout-form");
  if (!checkoutForm) return;

  // Initialize customer type handler
  new CustomerTypeHandler("checkout");

  // Initialize coupon handler
  couponHandler();

  // Check if iyzipay form has content and handle layout
  const handleIyzipayForm = () => {
    const iyzipayForm = document.getElementById("iyzipay-checkout-form");
    const customerDetails = document.querySelector(".customer-details");
    const checkoutForm = document.querySelector(".checkout-form");
    const checkoutActions = document.querySelector(".checkout-actions");
    const paymentSection = document.querySelector(".payment-section");

    if (iyzipayForm && iyzipayForm.children.length > 0) {
      // Hide customer details and move iyzipay form to its place
      if (customerDetails && checkoutForm) {
        customerDetails.style.display = "none";
        iyzipayForm.style.gridColumn = "1";
        checkoutForm.insertBefore(iyzipayForm, checkoutForm.firstChild);
      }

      // Hide order review content but keep the heading
      if (checkoutActions) checkoutActions.style.display = "none";
      if (paymentSection) paymentSection.style.display = "none";

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  // Set up mutation observer to watch for content being added to the iyzipay form
  const iyzipayForm = document.getElementById("iyzipay-checkout-form");
  if (iyzipayForm) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          handleIyzipayForm();
          break;
        }
      }
    });

    observer.observe(iyzipayForm, {
      childList: true,
      subtree: false,
    });
  }

  // Add message container to the page
  const messageContainer = document.createElement("div");
  messageContainer.className = "checkout-messages";
  document.body.appendChild(messageContainer);

  // Helper function to show messages
  const showMessage = (message, type = "error") => {
    const messageElement = document.createElement("div");
    messageElement.className =
      type === "error" ? "checkout-error" : "woocommerce-message";
    messageElement.textContent = message;
    messageContainer.appendChild(messageElement);

    setTimeout(() => {
      messageElement.style.opacity = "0";
      setTimeout(() => messageElement.remove(), 300);
    }, 5000);
  };

  // Updated Shipping Toggle & Real-time copy logic
  const shippingToggle = document.getElementById("use_billing_for_shipping");
  const shippingFields = document.querySelector(".shipping-fields");

  if (shippingToggle && shippingFields) {
    function copyField(billingField) {
      const shippingFieldName = billingField.name.replace(
        "billing_",
        "shipping_"
      );
      const shippingField = document.querySelector(
        `form.checkout-form [name="${shippingFieldName}"]`
      );
      if (shippingField) {
        shippingField.value = billingField.value;
        if (shippingField.name === "shipping_customer_type") {
          shippingField.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }

    shippingToggle.addEventListener("change", () => {
      if (shippingToggle.checked) {
        shippingFields.style.display = "none";
        document
          .querySelectorAll("form.checkout-form [name^='billing_']")
          .forEach(copyField);
      } else {
        shippingFields.style.display = "block";
      }
    });

    document
      .querySelectorAll("form.checkout-form [name^='billing_']")
      .forEach((billingField) => {
        billingField.addEventListener("input", () => {
          if (shippingToggle.checked) {
            copyField(billingField);
          }
        });
      });
  }

  // Form validation and submission
  if (checkoutForm) {
    const formInputs = checkoutForm.querySelectorAll("input, select, textarea");
    const shippingToggle = document.getElementById("use_billing_for_shipping");
    const termsCheckbox = checkoutForm.querySelector('input[name="terms"]');

    if (termsCheckbox) {
      termsCheckbox.addEventListener("change", () => {
        const container = termsCheckbox.closest(".terms-checkbox");
        if (container && termsCheckbox.checked) {
          container.classList.remove("error");
        }
      });
    }

    // ** START: USE TRANSLATED VARIABLES FOR VALIDATION **
    const validationRules = {
      email: {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: checkoutVars.messages.invalidEmail,
      },
      phone: {
        pattern: /^\+?[\d\s-]{8,}$/,
        message: checkoutVars.messages.invalidPhone,
      },
      postcode: {
        pattern: /^[A-Z0-9\s-]{3,}$/i,
        message: checkoutVars.messages.invalidPostcode,
      },
      required: {
        pattern: /.+/,
        message: checkoutVars.messages.required,
      },
      turkish_id: {
        pattern: /^[0-9]{11}$/,
        message: checkoutVars.messages.stockErrors.invalidTurkishId,
        maxLength: 11,
        inputFilter: (value) => /^\d*$/.test(value),
      },
      tax_id: {
        pattern: /^[0-9]{10}$/,
        message: checkoutVars.messages.stockErrors.invalidTaxId,
        maxLength: 10,
        inputFilter: (value) => /^\d*$/.test(value),
      },
    };
    // ** END: USE TRANSLATED VARIABLES FOR VALIDATION **

    const validateField = (input) => {
      const field = input.getAttribute("name");
      const value = input.value.trim();
      const isRequired = input.hasAttribute("required");
      let isValid = true;
      let errorMessage = "";

      if (isRequired && !value) {
        isValid = false;
        errorMessage = validationRules.required.message; // Use variable
      }

      if (isValid && field.includes("email") && value) {
        isValid = validationRules.email.pattern.test(value);
        if (!isValid) errorMessage = validationRules.email.message;
      }

      if (isValid && field.includes("phone") && value) {
        isValid = validationRules.phone.pattern.test(value);
        if (!isValid) errorMessage = validationRules.phone.message;
      }

      if (isValid && field.includes("postcode") && value) {
        isValid = validationRules.postcode.pattern.test(value);
        if (!isValid) errorMessage = validationRules.postcode.message;
      }

      if (field === "billing_turkish_id_num" && value) {
        isValid = validationRules.turkish_id.pattern.test(value);
        if (!isValid) errorMessage = validationRules.turkish_id.message;
      }

      if (field === "billing_tax_id_num" && value) {
        isValid = validationRules.tax_id.pattern.test(value);
        if (!isValid) errorMessage = validationRules.tax_id.message;
      }

      const errorElement = input.parentElement.querySelector(".field-error");
      if (!isValid) {
        input.classList.add("error");
        if (!errorElement) {
          const error = document.createElement("span");
          error.className = "field-error";
          error.textContent = errorMessage;
          input.parentElement.appendChild(error);
        } else {
          errorElement.textContent = errorMessage;
        }
      } else {
        input.classList.remove("error");
        if (errorElement) errorElement.remove();
      }

      return isValid;
    };

    const validateForm = () => {
      let isFormValid = true;

      formInputs.forEach((input) => {
        if (shippingToggle?.checked && input.name.startsWith("shipping_"))
          return;
        if (input.name.match(/shipping_(company|postcode|address_2)$/)) return;

        if (!shippingToggle?.checked && input.name.startsWith("shipping_")) {
          if (!input.name.match(/shipping_(company|postcode|address_2)$/)) {
            if (!validateField(input)) isFormValid = false;
          }
        }

        if (input.name.startsWith("billing_")) {
          if (!validateField(input)) isFormValid = false;
        }
      });

      if (termsCheckbox && !termsCheckbox.checked) {
        isFormValid = false;
        const termsContainer = termsCheckbox.closest(".terms-checkbox");
        if (termsContainer) {
          termsContainer.classList.add("error");
        }
      }

      return isFormValid;
    };

    checkoutForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      document
        .querySelectorAll(".woocommerce-message, .checkout-error, .field-error")
        .forEach((el) => el.remove());

      const isFormValid = validateForm();

      if (isFormValid) {
        try {
          const submitButton = checkoutForm.querySelector(
            'button[type="submit"]'
          );
          submitButton.disabled = true;
          submitButton.innerHTML = `<span class="spinner"></span> ${checkoutVars.messages.processing}`;
          checkoutForm.classList.add("processing");

          const formData = new FormData(checkoutForm);
          formData.append("action", "process_checkout");
          formData.append("security", checkoutVars.nonce);

          const selectedPaymentMethod = document.querySelector(
            'input[name="payment_method"]:checked'
          ).value;
          formData.append("payment_method", selectedPaymentMethod);

          const response = await fetch(checkoutVars.ajaxUrl, {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Cache-Control": "no-cache",
            },
            body: new URLSearchParams(formData),
          });

          if (!response.ok)
            throw new Error(`HTTP error! status: ${response.status}`);

          const result = await response.json();

          if (result.success) {
            if (result.data && result.data.order_completed) {
              sessionStorage.setItem("order_completed", "true");
              sessionStorage.removeItem("checkout_applied_coupons");
              sessionStorage.removeItem("checkout_page_visited");
            }

            if (selectedPaymentMethod === "direct") {
              if (result.data && result.data.redirect) {
                window.location.href = result.data.redirect;
              } else {
                showMessage(checkoutVars.messages.systemError);
              }
            } else {
              sessionStorage.setItem("checkout_in_progress", "true");
              const iyzipayFormContainer = document.getElementById(
                "iyzipay-checkout-form"
              );
              if (iyzipayFormContainer) {
                iyzipayFormContainer.innerHTML = "";
                const scriptContainer = document.createElement("div");
                scriptContainer.innerHTML = result.data.checkoutFormContent;
                iyzipayFormContainer.appendChild(scriptContainer);
                const scriptContent =
                  result.data.checkoutFormContent.match(
                    /<script[^>]*>([\s\S]*?)<\/script>/i
                  )?.[1] || "";
                if (scriptContent) {
                  const newScript = document.createElement("script");
                  newScript.text = scriptContent;
                  document.body.appendChild(newScript);
                }
              }
            }
          } else {
            handleErrors(result, checkoutForm);
          }
        } catch (error) {
          console.error("Checkout error:", error);
          showMessage(checkoutVars.messages.systemError);
        } finally {
          resetFormState(checkoutForm);
        }
      } else {
        const firstInvalidElement = checkoutForm.querySelector(
          ".form-row .error, .terms-checkbox.error"
        );
        if (firstInvalidElement) {
          const errorContainer =
            firstInvalidElement.closest(".form-row") ||
            firstInvalidElement.closest(".terms-checkbox");
          if (errorContainer) {
            errorContainer.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }
      }
    });

    if (shippingToggle) {
      shippingToggle.addEventListener("change", () => {
        const shippingFieldsContainer =
          document.querySelector(".shipping-fields");
        if (shippingFieldsContainer) {
          shippingFieldsContainer
            .querySelectorAll(".field-error")
            .forEach((el) => el.remove());
          shippingFieldsContainer
            .querySelectorAll(".error")
            .forEach((el) => el.classList.remove("error"));
        }
      });
    }

    const handleErrors = (result, form) => {
      if (result.data?.stock_errors) {
        const stockErrorContainer = document.createElement("div");
        stockErrorContainer.className = "checkout-error stock-errors";
        const mainMessage = document.createElement("p");
        mainMessage.textContent = result.data.message;
        stockErrorContainer.appendChild(mainMessage);
        const errorList = document.createElement("ul");
        result.data.stock_errors.forEach((error) => {
          const li = document.createElement("li");
          li.textContent = error;
          errorList.appendChild(li);
        });
        stockErrorContainer.appendChild(errorList);
        form.insertBefore(stockErrorContainer, form.firstChild);
        stockErrorContainer.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        return;
      }

      if (result.data?.field_errors) {
        Object.entries(result.data.field_errors).forEach(([field, message]) => {
          const input = form.querySelector(`[name="${field}"]`);
          if (input) {
            const formRow = input.closest(".form-row");
            if (formRow) {
              formRow.classList.add("has-error");
              const errorSpan = document.createElement("span");
              errorSpan.className = "field-error";
              errorSpan.textContent = message;
              formRow.appendChild(errorSpan);
            }
          }
        });
        showMessage(checkoutVars.messages.correctErrorsBelow); // Use translated variable
        const firstError = document.querySelector(".has-error");
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else {
        showMessage(result.data?.message || checkoutVars.messages.error);
      }
    };

    const resetFormState = (form) => {
      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton && !form.classList.contains("completed")) {
        submitButton.disabled = false;
        submitButton.innerHTML = checkoutVars.messages.placeOrder;
      }
      form.classList.remove("processing");
    };

    formInputs.forEach((input) => {
      input.addEventListener("input", () => {
        const formRow = input.closest(".form-row");
        if (formRow) {
          formRow.classList.remove("has-error");
          const errorElement = formRow.querySelector(".field-error");
          if (errorElement) errorElement.remove();
        }
      });
    });
  }

  const billingCheckbox = document.getElementById("billing_same_as_shipping");
  const billingDetails = document.querySelector(".billing-details");

  if (billingCheckbox && billingDetails) {
    billingCheckbox.addEventListener("change", () => {
      billingDetails.style.display = billingCheckbox.checked ? "none" : "block";
    });
  }
});
